<template>
    <p :endTime="endTime" class="flex-center">
        <slot v-if="type == 1">
            <span class="box">{{ day }}</span>&nbsp;:&nbsp;<span class="box">{{ hour }}</span>&nbsp;:&nbsp;<span class="box">{{ min }}</span>&nbsp;:&nbsp;<span class="box">{{ second }}</span>
        </slot>
        <slot v-if="type == 2">
            <span class="big-box">{{ day }}</span><span class="test">{{$t('300212')}}</span><span class="big-box">{{ hour }}</span><span class="test">{{$t('300213')}}</span><span class="big-box">{{ min }}</span><span class="test">{{$t('300214')}}</span><span class="big-box">{{ second }}</span><span class="test">{{$t('300215')}}</span>
        </slot>
        <slot v-if="type == 3">
            <span class="text">{{ day }}D</span>&nbsp;:&nbsp;<span class="text">{{ hour }}H</span>&nbsp;:&nbsp;<span class="text">{{ min }}M</span>&nbsp;:&nbsp;<span class="text">{{ second }}S</span>
        </slot>
    </p>
</template>
<script>
export default {
    data() {
        return {
            day: '00',
            hour: '00',
            min: '00',
            second: '00',
        }
    },
    props: {
        endTime: {
            type: [String, Number],
            default: '',
        },
        type: {
            type: [String, Number],
            default: '1',
        },
    },
    watch: {
        endTime() {
            this.countDown(this.endTime)
        },
    },
    mounted() {
        this.countDown(this.endTime)
    },
    methods: {
        countDown(endTime) {
            let self = this
            let timer = setInterval(function () {
                let nowTime = new Date()
                let t = endTime - nowTime.getTime()
                if (t > 0) {
                    let day = Math.floor(t / 86400000)
                    let hour = Math.floor((t / 3600000) % 24)
                    let min = Math.floor((t / 60000) % 60)
                    let sec = Math.floor((t / 1000) % 60)
                    self.day = day < 10 ? '0' + day : day
                    self.hour = hour < 10 ? '0' + hour : hour
                    self.min = min < 10 ? '0' + min : min
                    self.second = sec < 10 ? '0' + sec : sec
                } else {
                    clearInterval(timer)
                    self.$emit('clearTime')
                    self.day = '00'
                    self.hour = '00'
                    self.min = '00'
                    self.second = '00'
                }
            }, 1000)
        },
    },
}
</script>
<style lang="scss" scoped>
// @import '../../assets/css/mixin';
@import '../assets/css/mixin.scss';
// @import '../../assets/css/variable';
@import '../assets/css/variableName.scss';
span.box {
    display: inline-block;
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    // font-size: $font-size-small;
    font-family: D-DIN-Bold;
    @include font_color('font-color-2');
    @include background_color('input-bg-color');
    border: 1px solid;
    @include border_color('border-color-normal');
    border-radius: 2px;
}
span.big-box {
    display: inline-block;
    width: torem(32);
    height: torem(36);
    text-align: center;
    line-height: torem(36);
    font-size: torem(16);
    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
    font-weight: 600;
    // @include font_color('font-color-2');
    // @include background_color('input-bg-color');
    // @include border_color('border-color-normal');
    background-color: rgba(96, 96, 101, 1);
    color: #FFFFFF;
    border-color: rgba(96, 96, 101, 1) !important;
    border: torem(1) solid;
    border-radius: torem(2);
}
span.text {
    display: inline-block;
    // font-size: $font-size-small;
    @include font_color('font-color');
}
.test{
    padding: torem(14) torem(10);
    font-size: torem(12);
    font-weight: 500;
    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
    color: #606065;
}
</style>


// WEBPACK FOOTER //
// src/compontents/christmasCountDown.vue